// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z\"/> </svg> ";
// Exports
module.exports = code;